import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/app/common/common-components/ui/Dialog";
import { VatCalculator } from "./calculators/VatCalculator";
import { BondCalculator } from "./calculators/BondCalculator";
import { TransferCostCalculator } from "./calculators/TransferCostCalculator";
import { CommissionCalculator } from "./calculators/CommissionCalculator";
import { AffordabilityCalculator } from "./calculators/AffordabilityCalculator";
import TabMenu from "@/app/common/common-components/ui/TabMenu";
import { useUserLocalPreferences } from "@/app/hooks/useUserLocalPreferences";

interface CalculatorsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  countryCode?: string;
  currencySymbol?: string;
}

export const CalculatorsDialog = ({ open, onOpenChange, countryCode, currencySymbol }: CalculatorsDialogProps) => {
  const { preferences, updatePreference } = useUserLocalPreferences();
  const [activeTab, setActiveTab] = useState(preferences.lastCalculatorTab || "commission");

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey);
    updatePreference("lastCalculatorTab", tabKey);
  };

  const TABS = [
    { key: "commission", label: "Commission" },
    { key: "bond", label: "Bond" },
    { key: "transfer", label: "Transfer Cost" },
    { key: "affordability", label: "Affordability" },
    { key: "vat", label: "VAT" },
  ].filter((tab) => tab.key !== "transfer" || countryCode === "RSA"); // Hide transfer cost calculator for Namibia

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="tw-max-w-7xl">
        <DialogHeader>
          <DialogTitle className="tw-text-xl tw-font-semibold">Financial Calculators</DialogTitle>
        </DialogHeader>
        <TabMenu className="tw-mb-4">
          {TABS.map((tab) => (
            <TabMenu.Item key={tab.key} active={activeTab === tab.key} onClick={() => handleTabChange(tab.key)}>
              {tab.label}
            </TabMenu.Item>
          ))}
        </TabMenu>
        <div className="tw-mt-4 tw-max-h-[70dvh] tw-overflow-y-auto">
          {activeTab === "vat" && <VatCalculator countryCode={countryCode} currencySymbol={currencySymbol} />}
          {activeTab === "bond" && <BondCalculator countryCode={countryCode} currencySymbol={currencySymbol} />}
          {activeTab === "transfer" && <TransferCostCalculator countryCode={countryCode} currencySymbol={currencySymbol} />}
          {activeTab === "commission" && <CommissionCalculator countryCode={countryCode} currencySymbol={currencySymbol} />}
          {activeTab === "affordability" && <AffordabilityCalculator countryCode={countryCode} currencySymbol={currencySymbol} />}
        </div>
      </DialogContent>
    </Dialog>
  );
};
